import { useCreateUrlWithQuery } from '../../hooks/useQuery';
import request from '../request';

export const getNotification = ({ userId, orgId, timezone }) =>
  request.base.get(
    useCreateUrlWithQuery('utility-v2/userNotifications', { timezone }),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateNotification = ({ userId, orgId, notificationId, isRead }) =>
  request.base.put(
    'utility-v2/userNotification',
    {
      notificationId,
      isRead,
    },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const deleteNotification = ({ userId, orgId, notificationId }) =>
  request.base.delete(
    `utility-v2/userNotification/${notificationId}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getNotificationStats = ({ userId, orgId }) =>
  request.base.get(
    'utility-v2/userNotificationStats',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
